export default __webpack_public_path__ + "components/forecast-table/static/freezing-graph_backdrop-snow-c4c977aeff827659a5ad406fc13119f9.jpg";